import { segment } from '@actions/analytics';
import { CHECKOUT_STARTED } from '@constants/segment';
import { DoubtsAIContext } from '@context/DoubtsAIContext';
import styled from '@emotion/styled';
import { mediaQuery } from '@styles/index';
import pushRoute from '@utils/pushRoute';
import { useCallback, useContext } from 'react';

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${mediaQuery.uptoMobile} {
    flex-direction: column;
  }
`;
const BaseButton = styled.button`
  width: 172px;
  height: 42px;
  border-radius: 4px;
  padding: 12px;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0%;
  cursor: pointer;
  border: 1px solid var(--color-divider);
  ${mediaQuery.uptoMobile} {
    margin-top: 16px;
    width: 90%;
  }
`;
const GetSubscriptionButton = styled(BaseButton)`
  width: 263px;
  background-color: var(--color-base-fill);
  color: var(--color-text-tertiary);
`;

const LimitReachedFooter = ({ goalUid, goalSlug }) => {
  const { limitReachedData } = useContext(DoubtsAIContext);

  const getOrRenewSubscrioption = useCallback(() => {
    if (!goalUid || !goalSlug) return;
    segment.track(CHECKOUT_STARTED, {
      goal_uid: goalUid,
      source: 'Doubts AI'
    });
    pushRoute(
      '/goal/[goalSlug]/[goalUID]/subscribe',
      `/goal/${goalSlug}/${goalUid}/subscribe`,
      {},
      'topics'
    );
  }, [goalUid, goalSlug]);
  return (
    <Container>
      <p
        style={{
          fontWeight: 600,
          fontSize: 14,
          letterSpacing: 0,
          textAlign: 'center',
          color: 'var(--color-text-primary)'
        }}
      >
        {limitReachedData?.text ?? "You've reached your limit"}
      </p>
      {limitReachedData?.cta_text && (
        <GetSubscriptionButton onClick={getOrRenewSubscrioption}>
          {limitReachedData.cta_text}
        </GetSubscriptionButton>
      )}
    </Container>
  );
};

export default LimitReachedFooter;
